import api from 'api'
import { LEADS_MODAL } from '../constants/endpointKeys'
import { type ILeadsModalResponse } from './types'

export async function leadsModal() {
  return await api
    .get<ILeadsModalResponse>(LEADS_MODAL)
    .then(({ data }) => data)
}
